// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__upuzi","rect-rotate":"loading_rect-rotate__AYGDN","fill-rect":"loading_fill-rect__Ccx1j"};